import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronRight } from '@mui/icons-material';
import { Box, Button, Grid, Typography } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { LinkButton, TranslucentContainer } from '../../../../../../../components';
import CardEvent from '../../../../components/CardEvent/CardEvent';
import { formatDate, formatTime } from '../../../../../../../utils';
import { APP_ROUTES } from '../../../../../../../constants/app-routes';
import FeesFormModal from './FeesFormModal';
import { setEvent } from '../../../../../../../core/events/action';

function EventsListAdmin({ events, showDescription }) {
  const dispatch = useDispatch();

  const [showFeesFormModal, setShowFeesFormModal] = useState(false);
  const [eventToUpdate, setEventToUpdate] = useState({});

  const openFeesFormModal = (event) => {
    setShowFeesFormModal(true);
    setEventToUpdate(event);
  };

  const closeFeesFormModal = () => {
    setShowFeesFormModal(false);
    setEventToUpdate({});
    // Clean store current event
    dispatch(setEvent({}));
  };

  const getFormattedDate = (event) => formatDate(event.parameters_event.event_date);

  const getFormattedTime = (event) =>
    `${formatTime(event?.parameters_event.hour_start_event, 'hA')} - ${formatTime(
      event?.parameters_event.hour_end_event,
      // eslint-disable-next-line prettier/prettier
      'hA'
    )}`;

  const getFormattedPrice = (event) =>
    Number(event.event_price).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });

  const eventDetails = (eventId = null) => {
    if (eventId === undefined) return '';
    return APP_ROUTES?.EVENT_DETAILS.replace(':eventId', eventId);
  };

  return (
    <>
      <Grid container marginTop={5} justifyContent="center">
        <TranslucentContainer>
          <Grid container justifyContent="start" marginTop={8}>
            {events.map((event) => (
              <Grid key={uuidv4()} item sm={5} lg={3} marginBottom={8} paddingLeft={8}>
                <CardEvent
                  title={event?.name}
                  image={event?.photo}
                  caption={<span>{event?.venue?.name}</span>}
                  status={event?.status}
                  cardFooter={
                    <div>
                      <div>
                        <Button
                          onClick={() => openFeesFormModal(event)}
                          sx={{ color: '#EE7B57', textTransform: 'none' }}>
                          Manage Fees <ChevronRight sx={{ fill: '#EE7B57' }} />
                        </Button>
                      </div>
                      <div>
                        <LinkButton
                          to={eventDetails(event?.id)}
                          variant="text"
                          sx={{ color: '#EE7B57', textTransform: 'none' }}>
                          View Event Details
                          <ChevronRight sx={{ fill: '#EE7B57' }} />{' '}
                        </LinkButton>
                      </div>
                    </div>
                  }>
                  <Box>
                    <Typography gutterBottom variant="caption" color="text.secondary">
                      {getFormattedDate(event)}, {getFormattedTime(event)}
                    </Typography>

                    {showDescription && (
                      <Typography gutterBottom variant="subtitle2" color="text.primary">
                        <>&bull; {event.description}</>
                      </Typography>
                    )}
                  </Box>
                </CardEvent>
              </Grid>
            ))}
          </Grid>
        </TranslucentContainer>
      </Grid>
      <FeesFormModal
        showFeesFormModal={showFeesFormModal}
        closeFeesFormModal={closeFeesFormModal}
        eventId={eventToUpdate.id}
      />
    </>
  );
}

export default EventsListAdmin;

EventsListAdmin.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      status: PropTypes.bool.isRequired,
      // eslint-disable-next-line prettier/prettier
    })
  ).isRequired,
  showDescription: PropTypes.bool,
};

EventsListAdmin.defaultProps = {
  showDescription: false,
};
